export const MESSAGES = {
  REQUIRED: "必須項目です",
  POST_CODE_ERROR: "半角数字、ハイフン付きで入力してください",
  TEL_ERROR: "電話番号が不正です",
  EMAIL_ERROR: "メールアドレスが不正です",
  TEXT_MAX_ERROR: (max) => `${max}文字以内で入力してください`,
  REQUIRED_ERROR_WITH_NAME: (field) => `${field}は必須項目です`,
  INVALID_NUMBER: "数値は16桁（小数部分は6桁）以内で入力してください",
  DIFFERENCES_REQUIRED: "相違がある場合は、相違内容は必須項目です",
  VALIDATION_ERROR: "入力内容が不正なため保存できませんでした",
  NO_CHANGES: "保存すべき変更はありません",
  POST_SAVE: "保存しました",
  POST_APPROVE: "承認しました",
  CONFIRMATION_LETTER_NOT_FOUND:
    "確認状が見つかりませんでした。トップページに戻ります。",
  RESPONSE_WAITING:
    "回答の入力が終わりましたら「次のアクションを選択する」から回答手続を進めてください。",
  REMANDED:
    "承認依頼が差し戻されました。内容を確認後、再度承認依頼をしてください。",
  APPROVAL_REQUESTED:
    "承認依頼が届いています。内容を確認後、回答送信または再度承認依頼をしてください。",
  WAITING_FOR_APPROVAL: "承認依頼中です。",
  RESPONSE_COMPLETED:
    "確認状は回答送信済みです。ご回答いただきありがとうございました。",
};

export default MESSAGES;
